import { render, staticRenderFns } from "./menu-impressum-view.vue?vue&type=template&id=1f7bd484&"
import script from "./menu-impressum-view.vue?vue&type=script&lang=js&"
export * from "./menu-impressum-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports